import React from 'react';

function MandatoryFieldNotice() {
    return (
        <div className="mt-3">
            <sub><span style={{color: 'red'}}>*</span> Pflichtfeld</sub>
        </div>
    )
}

export default MandatoryFieldNotice;